/**
 * URL-hash keys for the ocr-templates feature's deep-linkable overlays, bound
 * via `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the template id as a hash param (`#edit/5`).
 *
 * Two separate surfaces share this one constant: the listing page uses
 * `create` / `edit` / `delete` / `bulkDelete`; the template-config page uses
 * `addField` / `editField` / `deleteField` / `discard`. No key appears on both
 * pages, so nothing collides.
 */
export const OCR_TEMPLATES_HASH = {
  /** `#create` — OcrTemplateFormDialog in create mode (listing). */
  create: 'create',
  /** `#edit/<id>` — OcrTemplateFormDialog editing a specific template (listing). */
  edit: 'edit',
  /** `#delete/<id>` — single-template delete confirmation (listing). */
  delete: 'delete',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete',
  /** `#import` — OcrTemplatesImportDialog (bulk import from XLSX/JSON). */
  import: 'import',
  /** `#add-field` — AddCustomFieldDialog in create mode (config page). */
  addField: 'add-field',
  /** `#edit-field/<key>` — AddCustomFieldDialog editing a draft field (config page). */
  editField: 'edit-field',
  /** `#delete-field/<key>` — draft-field remove confirmation (config page). */
  deleteField: 'delete-field',
  /** `#discard` — discard-changes confirmation (config page). */
  discard: 'discard'
} as const;

export type OcrTemplatesHashKey =
  (typeof OCR_TEMPLATES_HASH)[keyof typeof OCR_TEMPLATES_HASH];
